import { Button, STYLE_ANCHOR } from '@eventbrite/eds-button';
import classNames from 'classnames';
import { GenericLazyString } from 'packages/infra/i18n/src';
import React, { useEffect, useRef, useState } from 'react';
import './ExpandableSection.scss';

export interface ExpandableSectionProps {
    initiallyExpanded?: boolean;
    maxContainerHeight: number;
    buttonTextCollapsed: GenericLazyString;
    buttonTextExpanded: GenericLazyString;
}

const EXTRA_HEIGHT = 25;

export const ExpandableSection: React.FunctionComponent<
    ExpandableSectionProps
> = ({
    children,
    maxContainerHeight,
    initiallyExpanded,
    buttonTextExpanded,
    buttonTextCollapsed,
}) => {
    const ref = useRef(null);
    const [isExpanded, setIsExpanded] = useState(!!initiallyExpanded);
    const [contentHeight, setContentHeight] = useState<number>(0);
    const shouldApplyMaxHeight =
        contentHeight > maxContainerHeight + EXTRA_HEIGHT;
    const containerHeight = shouldApplyMaxHeight
        ? `${maxContainerHeight}px`
        : 'auto';

    useEffect(() => {
        setContentHeight(
            (ref.current as unknown as HTMLDivElement)?.clientHeight ?? 0,
        );
    }, [ref]);

    return (
        <>
            <div
                className="expandable-section"
                style={{
                    height: isExpanded ? '100%' : containerHeight,
                }}
            >
                <div ref={ref}>{children}</div>
            </div>

            {shouldApplyMaxHeight && (
                <div
                    className={classNames({
                        'expandable-section__button--collapsed': !isExpanded,
                    })}
                >
                    <Button
                        style={STYLE_ANCHOR}
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? buttonTextExpanded : buttonTextCollapsed}
                    </Button>
                </div>
            )}
        </>
    );
};
